import React, { FC } from 'react';
import { MRT_Row } from 'material-react-table';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../table/Table';
import { IAuditLogDetails } from '../../store/tables/admin/audit-logs-details-data';

export const AuditLogsDetailsPanel: FC = (props: MRT_Row) => {
	// @ts-ignore
	const data = props?.row?.original;

	const affectedColumns = data?.affectedColumns ? JSON.parse(data?.affectedColumns) : [];
	const tableData: IAuditLogDetails[] = affectedColumns.map(el => ({
		name: el,
		oldValue: data?.oldValues?.[el],
		newValue: data?.newValues?.[el],
	}));

	return (
		<div className="fc-table-panel pb-5">
			<div className="col-md-6">
				<Table
					name={TablesNames.auditLogsDetailPanelTableData}
					data={tableData || []}
					isLoading={false}
					enableHiding={false}
					enableTopToolbar={false}
					enableBottomToolbar={false}
					enableDensityToggle={false}
					enableColumnActions={false}
					enableColumnResizing={false}
					enableFullScreenToggle={false}
				/>
			</div>
		</div>
	);
};
